<app-modal [info]="info" (closeModal)="closeModal($event)">
  <ng-template #titleContent>
    <h3 class="modal__title">
      @if (data?.multipleInfo) {
        {{
          'FOLDERS.FOLDER_PAGE.CANDIDATE_ACTIONS.MODALS.REMOVE.TITLE.MULTIPLE'
            | translate: { multipleInfo: data.multipleInfo }
        }}
      } @else {
        {{
          'FOLDERS.FOLDER_PAGE.CANDIDATE_ACTIONS.MODALS.REMOVE.TITLE.SINGLE'
            | translate: { name: data.name | translate }
        }}
      }
    </h3>
  </ng-template>
</app-modal>
